import { render, staticRenderFns } from "./Graphics.vue?vue&type=template&id=be4bd38a&scoped=true&"
import script from "./Graphics.vue?vue&type=script&lang=js&"
export * from "./Graphics.vue?vue&type=script&lang=js&"
import style0 from "./Graphics.vue?vue&type=style&index=0&id=be4bd38a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4bd38a",
  null
  
)

export default component.exports